module.exports = __webpack_public_path__ + "static/media/vi.376712e3.svg";